/**
 * Модель для работы с картами
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import MapsService from '../services/MapsService';
import { IId, IMaps } from './types';

interface IState {
  list: IMaps[];
}

const initialState: IState = {
  list: []
};

export const infrastructureMaps = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setMaps(state: IState, payload: IMaps[]): IState {
      return {
        ...state,
        list: payload
      };
    }
  },
  effects: () => ({
    async getMaps(officeId: IId) {
      const { data } = await MapsService.getAll({ officeId });

      // MOCK
      this.setMaps(data.reverse());
    },
    resetMaps() {
      this.setMaps(initialState.list);
    }
  })
});
